import { Link } from "react-router-dom";
import { Twitter, Linkedin } from "lucide-react";

const QUICK_LINKS = [
  { label: "Platform", to: "/#platform", testid: "footer-link-platform" },
  { label: "For Media", to: "/for-media", testid: "footer-link-media" },
  { label: "For Journalists", to: "/for-journalists", testid: "footer-link-journalists" },
  { label: "Methodology", to: "/methodology", testid: "footer-link-methodology" },
  { label: "About", to: "/about", testid: "footer-link-about" },
  { label: "Contact", to: "/contact", testid: "footer-link-contact" },
];

const LEGAL_LINKS = [
  { label: "Privacy Policy", to: "/privacy", testid: "footer-link-privacy" },
  { label: "Terms of Use", to: "/terms", testid: "footer-link-terms" },
  { label: "Disclaimer", to: "/disclaimer", testid: "footer-link-disclaimer" },
];

const Footer = () => (
  <footer className="bg-[#0b1322] text-slate-300" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 sm:grid-cols-2 lg:grid-cols-4">
      <div>
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-white p-1">
            <img src="/anlytx-logo.png" alt="Anlytx logo" className="h-7 w-7" />
          </span>
          <span className="font-heading text-base font-bold tracking-tight text-white">Anlytx for Elections</span>
        </div>
        <p className="mt-4 text-sm leading-relaxed text-slate-400">
          India's election intelligence platform. Data &rarr; Insight.
        </p>
        <p className="mt-4 font-mono-data text-[10px] uppercase tracking-[0.2em] text-slate-500">
          Factual &bull; Neutral &bull; Methodology-first
        </p>
      </div>

      <nav aria-label="Quick links">
        <h3 className="font-mono-data text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Quick Links</h3>
        <ul className="mt-4 space-y-2.5">
          {QUICK_LINKS.map((l) => (
            <li key={l.testid}>
              <Link to={l.to} data-testid={l.testid} className="text-sm text-slate-400 transition-colors hover:text-white">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <nav aria-label="Legal">
        <h3 className="font-mono-data text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Legal</h3>
        <ul className="mt-4 space-y-2.5">
          {LEGAL_LINKS.map((l) => (
            <li key={l.testid}>
              <Link to={l.to} data-testid={l.testid} className="text-sm text-slate-400 transition-colors hover:text-white">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div>
        <h3 className="font-mono-data text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Parent Company</h3>
        <p className="mt-4 text-sm leading-relaxed text-slate-400">A product of SevenM Technologies Pvt. Ltd.</p>
        <a
          href="https://sevenm.in"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-link-sevenm"
          className="mt-2 inline-block text-sm font-medium text-red-400 transition-colors hover:text-red-300"
        >
          sevenm.in
        </a>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-6 py-6 sm:flex-row">
        <p className="text-xs text-slate-500">&copy; 2026 SevenM Technologies Private Limited. All rights reserved.</p>
        <div className="flex items-center gap-4">
          <a
            href="https://x.com/TeamSevenM"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Anlytx for Elections on X"
            data-testid="footer-social-x"
            className="text-slate-500 transition-colors hover:text-white"
          >
            <Twitter className="h-4 w-4" />
          </a>
          <a
            href="https://www.linkedin.com/company/sevenm-technologies-private-limited"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Anlytx for Elections on LinkedIn"
            data-testid="footer-social-linkedin"
            className="text-slate-500 transition-colors hover:text-white"
          >
            <Linkedin className="h-4 w-4" />
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
